<template>
	<div class="xs-12 p4">
		<core-form-input
			componentName="j-base-select"
			name="code"
			:options="options.exclusionsCodes"
			:label="$t('exclusion_code')"
			v-validate="'required'"
			v-model="form.code"
			:validationErrors="errors"
		/>

		<core-form-input
			class="mt6"
			componentName="j-base-input-long-text"
			name="remarks"
			:options="options.remarks"
			:label="$t('remarks')"
			v-model="form.remarks"
		/>

		<!-- Buttons -->
		<div class="flex xs-between mt6">
			<j-button :isLoading="isLoading" @click="handleSave">
				{{ $t("save") }}
			</j-button>
			<j-button @click="handleCancel" type="bordered">
				{{ $t("cancel") }}
			</j-button>
		</div>
	</div>
</template>

<script>
/**
 * This component is responsible for creation and update of exclusions
 * Exclusion can be added on offer or directly on policy
 * It's a smart component calling APIs
 *
 */
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"
import api from "../api/"
import get from "lodash.get"

export default {
	components: {
		CoreFormInput,
		JButton
	},

	props: {
		policyId: {
			type: String,
			required: true,
			default: ""
		},

		offerId: {
			validator(val) {
				return typeof val === "string" || val === null
			},
			required: false,
			default: null
		},

		/**
		 * This is important for settings, we get it from product.pricing
		 */
		productId: {
			type: Object,
			required: true,
			default: () => ({
				plan: null,
				type: null,
				version: null
			})
		}
	},

	data() {
		return {
			// When saving is in progress
			isLoading: false,

			// Form payload
			form: {
				code: null,
				remarks: null
			},

			// Options for select boxes
			options: {
				type: [
					{ name: this.$t("percentage"), value: "ratio" },
					{ name: this.$t("flat"), value: "flat" }
				],
				exclusionsCodes: []
			}
		}
	},

	methods: {
		async fetchExclusionsSettings() {
			const res = await api.exclusionsSettings({
				where: { productId: this.productId }
			})

			// Process codes
			const codes = get(
				res,
				"data.products_2.list[0].exclusionSettings.codeNames",
				[]
			)
			if (!codes) return

			// Prepare it for select box
			this.options.exclusionsCodes = codes.map(item => ({
				name: `${item.code} - ${item.name}`,
				value: item.code
			}))
		},

		async handleSave() {
			const isValid = await this.$validator.validate()
			if (!isValid) return

			// Wheter to add exclusion to offer or directly to policy is defined
			// via offerId, if it's null, it will be added directly on policy
			let offerId = this.offerId ? this.offerId : null

			this.isLoading = true
			const res = await api.addExclusion({
				policyId: this.policyId,
				input: {
					offerId,
					code: this.form.code,
					remark: this.form.remarks
				}
			})
			this.isLoading = false

			// Check errors
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			this.$emit("created")
		},

		handleCancel() {
			this.$emit("cancelled")
		}
	},

	created() {
		// Fetch exclusion settings
		this.fetchExclusionsSettings()
	}
}
</script>
